import { MagnifyingGlassIcon } from '@heroicons/react/20/solid'

export default function UserDirectoryInputBox({ 
    placeholder, 
    type = 'number',
    value, 
    onChange = () => {},
}) {
    return (
        <div className='flex rounded-md'>
            <div className="relative flex flex-grow items-stretch focus-within:z-10">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
                </div>

                <input
                    type={type}
                    name="key"
                    id="key"
                    className="w-full rounded-md py-2 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400"
                    placeholder={placeholder}
                    value={value ?? ''}
                    onChange={(event) => onChange(event.target.value)}
                />
            </div>
        </div>
    )
}